<template>
<section class="layout" :class="{'ui-fixed':isFixed,'ui-mini':isMini, 'ui-mini--open':navShown}">
    <div class="layout__outsideInner">
      <aside class="layout__aside">
          <header slot="logo" class="layout__logo"><img :src="imgLogo" alt="logo"></header>
          <Navigation
              theme="dark"
              mode="vertical"
              :active="active"
              :opens="opens"
              :list="navigation">
          </Navigation>
      </aside>
     <section class="layout__wrapper">
        <LayoutHeader class="adm-flex-group">
            <div class="ui-grow" v-if="isMini">
              <a href="javascript:;" class="btnNav" @click="showNav(!navShown)"><iv-icon size="28" type="ios-menu"></iv-icon></a>
            </div>
            <Navigation
                class="layout__navi"
                :active="stage"
                :list="stageList">
            </Navigation>
        </LayoutHeader>
        <div class="layout__content">
            <Crumb :route="$route"></Crumb>
            <div class="layout__inner">
                <router-view></router-view>
            </div>
        </div>
        <LayoutFooter class="layout__footer"></LayoutFooter>
     </section>
    </div>
</section>
</template>
<script>
import Navigation from "./Navigation2";
import LayoutFooter from "./Footer";
import LayoutHeader from "./Header";
import Crumb from "./Crumb";
import { mapActions, mapMutations, mapGetters } from 'vuex';

import imgLogo from "@/assets/images/headerLogo.png";

import { getCrumb } from "@/routes/";

const resize = vm=>{
    var lastClientWidth = document.body.clientWidth
    return function(){
        const mini = document.body.clientWidth <= 768
        vm.isMini = mini
        vm.isFixed = !mini
        if(vm.navShown && vm.isMini) vm.navShown = document.body.clientWidth === lastClientWidth ? vm.navShown : false
    }
}

export default {
    components: { Navigation, LayoutFooter, LayoutHeader, Crumb },
    beforeMount () {
        window.addEventListener('resize', resize(this))
    },
    data(){
        const mini = document.body.clientWidth <= 768
        return {
            imgLogo,
            isFixed: !mini,
            navShown: true,
            navWidth: 200,
            isMini: mini,
            active: "",
            opens: []
        }
    },
    beforeRouteEnter(to, from, next){
      next(vm=>{
          vm.$nextTick(()=>vm.updateNav(vm,to))
      })
    },
    beforeRouteUpdate(to, from, next){
      this.updateNav(this,to)
      next()
    },
    beforeDestroy () {
        window.removeEventListener('resize', resize(this))
    },
    methods: {
        updateNav(vm, route){
            const currentNode = [...getCrumb(route.name)].pop();
            const crumb = getCrumb(route.name).filter(node=>node.type == 'iv-submenu');
            const parentNode = crumb[Math.max(crumb.length-1, 0)];
            vm.opens = [parentNode.name];
            vm.active = currentNode.name;
            if(vm.navShown && vm.isMini) vm.navShown = false
        },
        showNav(shown){
            this.navShown = shown;
        }
    },
    computed: {
      ...mapGetters(['navigation','stage','stageList'])
    },
}
</script>
<style lang="scss">
.layout{
    background-color: #f5f5f5;
    &__navi{
        .ivu-menu-item,.ivu-menu-submenu{
            border-bottom: none !important;
            transition: none !important;
            padding: 0;
            > span{
                display: inline-block;
                line-height: 28px;
                border-bottom: 2px solid transparent;
            }
            &-active,&-selected,&:hover{
                color: initial !important;
                border-bottom: none !important;
                > span{
                    transition: all .2s ease-in-out;
                    color: #2d8cf0;
                    border-bottom: 2px solid #2d8cf0;

                }
            }
            &:after{
                content: "/";
                margin: 0 20px;
            }
            &:last-child{
                &:after{
                    content: "";
                }
            }
            .ivu-menu-submenu-title{
              display: inline-block;
            }
        }
        .ivu-menu-drop-list {
          .ivu-menu-item {
            &:after {
              content: "";
            }
            &-active, &-selected {
              background-color: transparent !important;
            }
          }
        }
    }
}
</style>
<style lang="scss" scoped>
.ivu-breadcrumb{
    margin-left: 3px;
}
.layout{
    background-color: #f5f5f5;
    &__outsideInner{
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: nowrap;
        min-height: 100vh;
        transition: transform .35s ease-in-out;
    }
    &__aside{
        flex-grow: 0;
        flex-shrink: 0;
        width: 200px;
        background-color: #464c5b;
        overflow: hidden;
        overflow-y: auto;
        transition: transform .35s ease-in-out;
        display: flex;
        flex-direction: column;
    }
    &__wrapper{
        position: relative;
        flex-grow: 1;
        zoom: 1;
        overflow: hidden;
        transition: margin-left .35s ease-in-out;
        padding-bottom: 3em;
    }
    &__footer{
        position: absolute;
        bottom: 1em;
        left: 1em;
        right: 1em;
        color: #999;
        text-align: center;
    }
    &__header{
        height: 45px;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0,0,0,.05);
        transition: margin-left .35s ease-in-out;
    }
    &__content{
        padding: 1em;
    }
    &__title{
        padding: 5px 15px;
        background: #fff;
        min-height: 45px;
        > h1{
            display: block;
            font-size: 20px;
            line-height: 30px;
            margin-top: 10px;
        };
    }
    &__inner{
        margin-top: 10px;
    }
    &__logo{
        padding: 3px 15px;
        background: #fff;
        min-height: 45px;
        > img{
            display: block;
            height: 38px;
        }
    }
    &.ui-fixed{
        .layout{
            &__aside{
                position: fixed;
                left: 0;
                top: 0;
                bottom: 0;
            }
            &__header{
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                margin-left: 200px;
                z-index: 10;
            }
            &__wrapper{
                margin-left: 200px;
            }
            // &__content{
            //     margin-top: 60px;
            // }
        }
    }
    &.ui-mini{
        overflow: hidden;
        // transform: translateX(-200px);
        .layout{
            &__outsideInner{
                transform: translateX(-200px);
            }
            &__aside{
                // position: absolute;
                // top: 0;
                // left: 0;
            }
            &__wrapper{
                flex-shrink: 0;
                width: 100%;
            }
        }
    }
    &.ui-mini--open{
        .layout{
            &__outsideInner{
                transform: translateX(0);
            }
        }
    }
}
.btnNav{
    padding: 0 15px;
    display: inline-block;
    line-height: 45px;
    > i {
        vertical-align: middle;
    }
}
.layout_title{
    font-size: 20px;
    margin-top: 20px;
}
</style>


